import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";

import Icon from "@mdi/react";
import { mdiContentSave, mdiContentSaveCog } from "@mdi/js";

const ProfileSaveLayer = (props) => {
   const [userPrefs, setUserPrefs] = useState({});
   const [asData, setAsData] = useState(false);

   useEffect(() => {
      props.userPrefs ? setUserPrefs(props.userPrefs) : null;
   }, []);

   useEffect(() => {
      userPrefs ? setAsData(true) : false;
   }, [userPrefs]);

   useEffect(() => {
      props.userPrefs ? setUserPrefs(props.userPrefs) : null;
   }, [props.userPrefs]);

   const handleUpdatePrefs = (e) => {
      const args = {
         userPrefs: {
            ...props.userPrefs,
            layers: e.target.checked,
         },
      };

      props.updateUserInfo({ prefs: args.userPrefs });
   };

   return (
      <div className={"w-100 bg-white rounded mb-3 p-4"}>
         <h6 className={"my-2 font-weight-bold "} style={{ fontSize: "13px" }}>
            Portail - affichage des données{" "}
         </h6>
         <div
            className="d-flex justify-content-between mt-3"
            style={{
               backgroundColor: "#F9F9F9",
               padding: "10px",
               borderRadius: "5px",
            }}
         >
            <span style={{ fontWeight: "500", fontSize: "11px" }}>
               Afficher les dernières données à l'actualisation
            </span>
            <div className="custom-control custom-switch">
               <input
                  type="checkbox"
                  className="custom-control-input ue-big-switch"
                  id={"profileSaveLayerInput"}
                  name={"profileSaveLayerInput"}
                  onChange={(e) => {
                     handleUpdatePrefs(e);
                  }}
                  defaultChecked={userPrefs.layers}
               />
               <label className="custom-control-label" htmlFor="profileSaveLayerInput">
                  {" "}
               </label>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      entity: state.MeReducer.entity,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      structureInfo: state.SubscribtionReducer.structureInfo,
      userPrefs: state.MeReducer.prefs,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(ProfileSaveLayer);
